import { ChartData } from "chart.js";

import { Translation } from "@/data/lang";

import { HistoricalRatio } from "../services/holdings-of-investors";

const colorMap: Partial<Record<keyof HistoricalRatio, string>> = {
  closePrice: "#0369A1",
  largeRatio: "#38BDF8",
  smallRatio: "#F87171",
};
export const extractShareholderDiversificationChartData = ({
  t,
  data,
}: {
  t: Translation;
  data: HistoricalRatio[];
}): ChartData<"line" | "bar"> => ({
  labels: data.map((d) => d.date),
  datasets: [
    {
      type: "line",
      label: t.analysis.chip.shareholderDiversification.closePrice,
      data: data.map((d) => d.closePrice ?? null),
      borderColor: colorMap.closePrice,
      backgroundColor: colorMap.closePrice,
      yAxisID: "y1",
      pointRadius: 0,
      spanGaps: true,
    },
    {
      type: "line",
      label: t.analysis.chip.shareholderDiversification.largeThresholdRatio,
      data: data.map((d) => d.largeRatio ?? null),
      borderColor: colorMap.largeRatio,
      backgroundColor: colorMap.largeRatio,
      yAxisID: "y",
      pointRadius: 0,
      spanGaps: true,
    },
    {
      type: "line",
      label: t.analysis.chip.shareholderDiversification.smallThresholdRatio,
      data: data.map((d) => d.smallRatio ?? null),
      borderColor: colorMap.smallRatio,
      backgroundColor: colorMap.smallRatio,
      yAxisID: "y",
      pointRadius: 0,
      spanGaps: true,
    },
  ],
});
